declare namespace $ {

	type $giper_baza_link_chip__link_giper_baza_vary_edit_1 = $mol_type_enforce<
		ReturnType< $giper_baza_vary_edit['link'] >
		,
		ReturnType< $giper_baza_link_chip['link'] >
	>
	export class $giper_baza_vary_edit extends $mol_vary_edit {
		link( ): $giper_baza_link
		Vary( ): $mol_vary_class
		Link_icon( ): $mol_icon_link
		Link( ): $giper_baza_link_chip
		type_dict( ): ({ 
			'Link': string,
		})  & ReturnType< $mol_vary_edit['type_dict'] >
	}
	
}

//# sourceMappingURL=edit.view.tree.d.ts.map